import React from 'react'
import { t } from 'i18next'
import { List } from '../../common/list/List'
import { IListState } from '../../../interfaces/IListState'
import { DashboardInfoCard } from '../DashboardInfoCard'
import { makeStyles, Text, tokens } from '@fluentui/react-components'
import { ConsequenceAndProbabilityRisk, RiskAnalysis } from '../../../api/schemas/schema'
import { getBiggestRisksColumns } from '../../../helpers/dashboardHelper'
import { BiggestRisk } from './BiggestRisk'
const useStyles = makeStyles({
   marginBottomPhone: {
      '@media screen and (max-width: 1007px)': {
         marginBottom: tokens.spacingVerticalS,
      },
   },
   // scrollContainer: { maxHeight: '164px', overflowY: 'auto' }, // Height = 3 risks (44px * 3 = 132px) + 32px for header
})

type BiggestRisksCardProps = {
   setRiskManagementState: React.Dispatch<React.SetStateAction<IListState<RiskAnalysis>>>
   biggestRisks: ConsequenceAndProbabilityRisk[]
}
export const BiggestRisksCard = ({ biggestRisks, setRiskManagementState }: BiggestRisksCardProps) => {
   const classes = useStyles()
   return (
      <>
         {biggestRisks?.length === 0 ? (
            <DashboardInfoCard
               title={t('DoARiskAssessment')}
               description={t('DoARiskAssessmentDescription')}
               buttonText={t('CreateRiskAssessment')}
               onClick={() => setRiskManagementState((prev) => ({ ...prev, open: true }))}
            />
         ) : (
            <>
               <Text size={600} weight="semibold" className={classes.marginBottomPhone}>
                  {t('BiggestRisks')}
               </Text>
               <List
                  // className={classes.scrollContainer}
                  beigeHeaderBackground
                  columns={getBiggestRisksColumns()}
                  items={biggestRisks}
                  renderPhoneBodyItem={(item) => <BiggestRisk risk={item} />}
               />
            </>
         )}
      </>
   )
}
